export interface ResourceUrlProps {
  type: string;
  url: string | string[];
  title: string;
  uniqueId: string;
  basePath?: string;
}

export interface ResourceUrlResult {
  resolvedUrl: string;
  shareUrl: string;
  parsedTitle: string;
  location: string;
  dataSrc: string;
  linkTo: string;
}

export function getResourceUrl({ type, url, title, uniqueId, basePath }: ResourceUrlProps): ResourceUrlResult {
  const location = basePath ?? window.location.pathname.split('/').slice(0, 3).join('/');
  const resolvedUrl = Array.isArray(url) ? (url[0] ?? '') : url;
  const shareUrl = Array.isArray(url) ? window.location.href : resolvedUrl;
  const parsedTitle = title.toLowerCase().replace(/-/g, '---').replace(/ /g, '-');

  const dataSrc = (() => {
    switch (type) {
      case 'pdf':
        return `https://stack.travpromobile.com/viewer.php?file=${resolvedUrl}`;
      case 'multi':
        return `#${uniqueId}`;
      default:
        return resolvedUrl;
    }
  })();

  const linkTo = (() => {
    switch (true) {
      case type === 'contact_us':
        return `${location}/contact`;
      case !!resolvedUrl: {
        const raw = resolvedUrl.includes('/') ? (resolvedUrl.split('/').pop() ?? resolvedUrl) : resolvedUrl;
        const go = raw.toLowerCase().replace(/-/g, '---').replace(/ /g, '-').replace('&', '%26');
        return `${location}/${go}`;
      }
      case !url && !!parsedTitle:
        return `${location}/${parsedTitle.replace('&', '%26')}`;
      default:
        return '';
    }
  })();

  return { resolvedUrl, shareUrl, parsedTitle, location, dataSrc, linkTo };
}
